// ExtendedProperty name of CLP label on a message item.
export const LABEL_PROPERTY_NAME = 'msip_labels';
export const LABEL_MODIFY_HEADER = 'X-MS-Exchange-Organization-ModifySensitivityLabel';
export const EMPTY_LABEL_GUID = '00000000-0000-0000-0000-000000000000';
export const STANDARD_LABEL_METHOD = 'Standard';
export const PRIVILEGED_LABEL_METHOD = 'Privileged';
